import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDropdown } from '../../../Redux/features/Stock/stockSlice';
import { DROPDOWN_FLAG } from '../../../config/config';
import { toast } from 'react-toastify';

const FilterSectionStoke = ({ Filter, setFilter, handleStokeFilter, handleReset, currentPath }) => {
	const handleFilterChange = (e) => {
		const { name, value } = e.target;

		if (/^[a-zA-Z0-9 ]*$/.test(value)) {
			setFilter((prevState) => ({
				...prevState,
				[name]: value,
			}));
		} else {
			toast.error('Special characters are not allowed.');
		}
		setFilter((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};

	const [CategoryData, setCategoryData] = useState([]);
	const [SubCategoryData, setSubCategoryData] = useState([]);
	const [ProductData, setProductData] = useState([]);
	const [filteredProducts, setFilteredProducts] = useState([]);
	const [inputValue, setInputValue] = useState('');
	const [isDropdownVisible, setDropdownVisible] = useState(false);

	const dispatch = useDispatch();
	const { isLoading } = useSelector((state) => state.stock);

	const [hasFetched, setHasFetched] = useState(false);

	useEffect(() => {
		if (hasFetched) return;

		const fetchData = async () => {
			try {
				const categoryData = await dispatch(getDropdown(DROPDOWN_FLAG.CATEGORY));
				const productData = await dispatch(getDropdown(DROPDOWN_FLAG.PRODUCT));
				const subCategoryData = await dispatch(getDropdown(DROPDOWN_FLAG.SUBCATEGORY));

				if (categoryData.payload && categoryData.payload.stock) {
					setCategoryData(categoryData.payload.stock);
				}
				if (productData.payload && productData.payload.stock) {
					setProductData(productData.payload.stock);
				}

				if (subCategoryData.payload && subCategoryData.payload.stock) {
					setSubCategoryData(subCategoryData.payload.stock);
				}

				setHasFetched(true);
			} catch (error) {
				console.error('Failed to fetch dropdown data:', error);
			}
		};

		fetchData();
	}, [dispatch, hasFetched]);

	// Handle product input change and filter products
	const handleProductInputChange = (e) => {
		const value = e.target.value;
		if (!/^[a-zA-Z0-9 ]*$/.test(value)) {
			return; // Block special characters
		}
		setInputValue(value);

		if (value) {
			// Filter products with case-insensitive matching
			const filtered = ProductData.filter((product) =>
				product.MasterValue.toLowerCase().includes(value.toLowerCase())
			);

			setFilteredProducts(filtered);
			setDropdownVisible(true);
		} else {
			setFilteredProducts([]);
			setDropdownVisible(false);
		}
	};

	// Handle selecting a product from the dropdown
	const handleSelectProduct = (product) => {
		setInputValue(product.MasterValue);
		setFilter((prevState) => ({
			...prevState,
			ProductId: product.MasterId,
		}));
		setDropdownVisible(false);
	};

	return (
		<div className='md:p-4 sm:p-2 '>
			<div className='flex flex-wrap gap-3 lg:mb-8 mb-4'>
				<div className={`relative max-[300px]:w-full`}>
					<input
						type='text'
						name='ProductId'
						className='p-2 border rounded w-full text-sm max-[400px]:text-xs'
						value={inputValue}
						onChange={handleProductInputChange}
						onBlur={() => setTimeout(() => setDropdownVisible(false), 200)}
						onFocus={() => setDropdownVisible(true)}
						placeholder='Search Product'
						autoComplete='off'
					/>
					{isDropdownVisible && !isLoading && filteredProducts.length > 0 && (
						<ul className='absolute w-full bg-white border rounded mt-1 max-h-60 overflow-y-auto z-10'>
							{filteredProducts.map((product) => (
								<li
									key={product.MasterId}
									className='p-2 hover:bg-gray-100 cursor-pointer text-sm max-[400px]:text-xs'
									onClick={() => handleSelectProduct(product)}>
									{product.MasterValue}
								</li>
							))}
						</ul>
					)}
					{isLoading && filteredProducts.length === 0 && (
						<ul className='absolute w-full bg-white border rounded mt-1 z-10'>
							<li className='p-2 text-gray-500 text-sm max-[400px]:text-xs'>Loading products...</li>
						</ul>
					)}
					{filteredProducts.length === 0 && inputValue && !isLoading && (
						<ul className='absolute w-full bg-white border rounded mt-1 z-10'>
							<li className='p-2 text-gray-500 '>No matching products found</li>
						</ul>
					)}
				</div>

				<div className='lg:w-auto w-1/4 max-[300px]:w-full'>
					<select
						name='Category'
						className='p-2 border rounded w-full lg:w-auto text-sm max-[400px]:text-xs  bg-white placeholder:opacity-20'
						value={Filter.Category || ''}
						onChange={handleFilterChange}>
						<option className=' text-sm max-[400px]:text-xs ' value=''>
							Category
						</option>
						{!isLoading && CategoryData.length > 0 ? (
							CategoryData.map((category) => (
								<option
									className=' text-sm max-[400px]:text-[10px]'
									key={category.MasterId}
									value={category.MasterId}>
									{category.MasterValue}
								</option>
							))
						) : (
							<option disabled>Loading categories...</option>
						)}
					</select>
				</div>
				<div className='lg:w-auto w-1/4 max-[300px]:w-full'>
					<select
						name='SubCategory'
						className='p-2 border rounded w-full lg:w-auto text-sm max-[400px]:text-xs  bg-white placeholder:opacity-20'
						value={Filter.SubCategory || ''}
						onChange={handleFilterChange}>
						<option className=' text-sm max-[400px]:text-xs '>SubCategory</option>
						{!isLoading && SubCategoryData.length > 0 ? (
							SubCategoryData.map((subcategory) => (
								<option
									className=' text-sm max-[400px]:text-[10px]'
									key={subcategory.MasterId}
									value={subcategory.MasterId}>
									{subcategory.MasterValue}
								</option>
							))
						) : (
							<option disabled>Loading Subcategories...</option>
						)}
					</select>
				</div>

				<div className='flex flex-row items-center justify-center gap-3 w-[52%] lg:w-auto max-[300px]:w-full'>
					<button
						type='button'
						onClick={() => {
							handleStokeFilter();
						}}
						className='bg-red-500 text-white px-4 md:py-2 py-1 max-[300px]:py-2 text-sm rounded w-full lg:w-auto'>
						Search
					</button>
					<button
						type='button'
						onClick={handleReset}
						className='bg-red-500 text-white px-4 md:py-2 py-1 max-[300px]:py-2 text-sm rounded w-full lg:w-auto'>
						Reset
					</button>
				</div>
			</div>
		</div>
	);
};

export default FilterSectionStoke;
